import { FROZEN_FOOD_CATEGORY_ID } from 'components/CategoryNav/sidebarFilterData';
import { Category } from 'types/schema';
import getParentCategoryIdFromPathname from 'utils/getParentCategoryIdFromPathname';

/**
 * Find category from categories.
 * Frozen Food virtual children reuse the same ids as real subcategories — when duplicates
 * exist, prefer the URL parent slug, otherwise prefer the non-virtual (real) category.
 */
function findCategory(categories: Category[], categoryId: number): Category | undefined {
  const topLevel = categories.find((c: Category) => c.id === categoryId);
  if (topLevel) {
    return topLevel;
  }

  const matches: Category[] = [];
  categories.forEach((c: Category) => {
    const child = c.children?.find((item: Category) => item.id === categoryId);
    if (child) {
      matches.push(child);
    }
  });

  if (matches.length <= 1) {
    return matches[0];
  }

  const pathname = typeof window !== 'undefined' ? window.location.pathname : '';
  const parentId = getParentCategoryIdFromPathname(pathname, categories);
  if (parentId != null) {
    const byParent = matches.find((item) => item.parent?.id === parentId);
    if (byParent) {
      return byParent;
    }
  }

  return matches.find((item) => item.parent?.id !== FROZEN_FOOD_CATEGORY_ID) ?? matches[0];
}

export default findCategory;
